import { Howl } from 'howler';

export default class Audio {
	constructor() {
		this.sounds = {};
		this.isMuted = false;
	}

	load(id, src) {
		const sound = new Howl({
			html5: false,
			src: [src],
		});
		//const sound = new window.Audio(src);
		////remove old sound and unload and destroy
		if (this.sounds[id] && this.sounds[id].unload) {
			this.sounds[id].unload();
		}

		this.sounds[id] = sound;
	}

	async play(id) {
		if (this.isMuted) {
			return;
		}

		const sound = this.sounds[id];
		if (!sound) {
			return;
		}

		sound.play();
	}

	muteSet(isMuted) {
		this.isMuted = isMuted;

		// if (isMuted) Howler.volume(0);
		// else Howler.volume(1);

		// if (isMuted) PIXI.sound.volumeAll = 0;
		// else PIXI.sound.volumeAll = 1;
	}
}
